import messages from './common.json' with { type: 'json' };

export const commonFi: Readonly<typeof messages> = messages;
